import { Directive, Input, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { isNullOrUndefined } from '@pineapplelab/util';
import { AuthService } from '../../services/auth/auth.service';
import { ProjectService } from '../../services/project/project.service';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionsDirective {

	@Input('hasPermission') permission: number | number[] = null;
	@Input('hasPermissionInclusive') inclusive = true;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		private authService: AuthService,
		private projectService: ProjectService
	) { }

	ngOnInit() {
		this.viewContainerRef.clear();
		this.checkAccess();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!isNullOrUndefined(changes['permissions'])) {
			this.checkAccess();
		}
	}

	checkAccess() {
		let access = false;
		if (!isNullOrUndefined(this.permission)) {
			access = this.getAccess();
		}
		if (access) {
			this.viewContainerRef.createEmbeddedView( this.templateRef )
		} else {
			this.viewContainerRef.clear();
		}
	}

	private getAccess(): boolean {
		const projectAccess = this.projectService.hasPermissions(this.permission, this.inclusive);

		if (!!this.authService.auth?.user) {
			const userAccess = this.authService.hasPermission(this.permission, this.inclusive);
			return projectAccess || userAccess;
		}

		return projectAccess;
	}


}
